/** Helpers for admin document labels and Cloudinary downloads. */

export function formatMimeLabel(mimeType?: string | null, fileName?: string | null): string {
  const mime = (mimeType || '').toLowerCase();
  if (mime.includes('pdf')) return 'PDF';
  if (mime.includes('jpeg') || mime.includes('jpg')) return 'JPG';
  if (mime.includes('png')) return 'PNG';
  if (mime.includes('gif')) return 'GIF';
  if (mime.includes('webp')) return 'WEBP';
  if (mime.startsWith('image/')) return 'Image';

  const ext = (fileName || '').split('.').pop()?.toLowerCase();
  if (ext && ext.length <= 5) return ext.toUpperCase();
  return 'File';
}

export function displayDocumentName(
  documentName?: string | null,
  mimeType?: string | null,
  documentType?: string | null
): string {
  const raw = (documentName || '').trim();
  const looksGeneric =
    !raw ||
    raw.toLowerCase() === 'file' ||
    raw.toLowerCase() === 'untitled' ||
    raw.toLowerCase() === 'blob';

  if (!looksGeneric) return raw;

  const typeLabel = (documentType || 'document')
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
  const format = formatMimeLabel(mimeType, raw);
  return `${typeLabel}.${format.toLowerCase()}`;
}

/**
 * Force a useful download filename. Cloudinary `fl_attachment` without a name
 * often saves as plain "file".
 */
export function buildDocumentDownloadUrl(
  url: string | undefined | null,
  fileName: string
): string {
  if (!url) return '';
  const safeName = encodeURIComponent(
    fileName.replace(/[^\w.\-()+ ]+/g, '_').replace(/\s+/g, '_')
  );

  if (url.includes('/raw/upload/')) {
    // Attachment transforms on raw files return an error page.
    return url;
  }

  if (url.includes('/upload/')) {
    // Avoid stacking fl_attachment if already present
    if (/\/upload\/[^/]*fl_attachment/.test(url)) {
      return url.replace(
        /fl_attachment(?::[^/]*)?/,
        `fl_attachment:${safeName}`
      );
    }
    return url.replace('/upload/', `/upload/fl_attachment:${safeName}/`);
  }

  return url;
}
